export { initDataDogRUM, addSMSDataDogUserAction } from "./lib/rum";
export { initDataDogLogging } from "./lib/logs";
export * from "./lib/types";
